import Axios from 'config/service.config'
import config from 'config/env_config'
import { getCobasiSessionCookie, setAuthCookies } from 'utils'
import { me } from 'services/userService'
import * as Sentry from '@sentry/browser'

export const authenticate = async ({ email, password, captchaToken }, authData, isPostLogin = true) => {
  try {
    const user = {
      login: email,
      password: password,
      captcha: captchaToken
    }

    let isAuthenticated = false
    let response = authData

    if (isPostLogin) {
      const { data } = await Axios.post('authenticate/login', user, { withCredentials: true })
      response = data
    }

    if (response.status === 'Success') {
      setAuthCookies({
        ...(isPostLogin) && { authCookie: response?.authCookie },
        cobasiToken: response.cobasiToken
      })

      const updateIntegration = true // flag para atualizar a base de dados quando fazer o login
      // Após fazer o login, verifica se o cadastro está completo.
      const { firstName, lastName, document, homePhone, phone, email, birthDate, isMktsrvTermsAccepted, isNewsletterOptIn } = (await me(updateIntegration)) || {}
      if (firstName && document && (homePhone || phone) && isMktsrvTermsAccepted && birthDate) {
        isAuthenticated = true

        Sentry.setUser({
          id: response.userId,
          email,
          username: `${firstName}${lastName ? ` ${lastName}` : ''}`
        })
      } else {
        // Caso não houver todos os dados obrigatórios cadastrados, limpa cookies
        // e informações do localStorage, para que o usuário complete o cadastro
        await logout(false)
      }

      return {
        user: {
          email,
          firstName,
          lastName,
          document,
          homePhone,
          phone,
          birthDate,
          isMktsrvTermsAccepted,
          isNewsletterOptIn
        },
        isAuthenticated,
        authorization: response?.authCookie?.value
      }
    }
    return {
      isAuthenticated
    }
  } catch (error) {
    return error
  }
}

export const getAccessKey = async (email) => {
  try {
    const payload = { email }
    const response = await Axios.post('authenticate/send-access-key', payload)
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const storePassword = ({ data }) => {
  window.localStorage.setItem('passwordRestToken', data.authenticationToken)
}

export const setPassword = async ({ email, password, keyCode, authenticationToken }) => {
  try {
    const payload = {
      email: email,
      password: password,
      authenticationToken: authenticationToken || window.localStorage.getItem('passwordRestToken'),
      accessKey: keyCode
    }

    const response = await Axios.post('authenticate/set-password', payload)
    window.localStorage.removeItem('passwordRestToken')
    return response
  } catch (error) {
    return error.response.data
  }
}

export const verifyKeyCode = async ({ email, keyCode }) => {
  const payload = {
    email: email,
    accessKey: keyCode
  }

  const data = await Axios.post('authenticate/validate-access-key', payload)

  setAuthCookies({
    authCookie: data.authCookie,
    cobasiToken: data.cobasiToken
  })
  window.localStorage.setItem('userId', data.userId)
  window.localStorage.setItem('email', email)

  return data
}

export const resetAuthCookies = () => {
  document.cookie = 'authCookie=;expires=Thu, 01 Jan 1970 00:00:00 UTC; Max-Age=-99999999; path=/;'
  document.cookie = 'accountAuthCookie=;expires=Thu, 01 Jan 1970 00:00:00 UTC; Max-Age=-99999999; path=/;'
  document.cookie = `X-Cobasi-User=;expires=Thu, 01 Jan 1970 00:00:00 UTC; Max-Age=-99999999; path=/;${process.env.ENV && process.env.ENV !== 'development' ? 'domain=.cobasi.com.br;' : ''}`
  getCobasiSessionCookie({ token: '', expiresAt: 'Thu, 01 Jan 1970 00:00:00 UTC' }, document)
}

export const logout = async (vtexLogout = true) => {
  resetAuthCookies()
  window.localStorage.removeItem('userId')
  window.localStorage.removeItem('email')
  window.localStorage.removeItem('vtexUserId')
  window.localStorage.removeItem('firstName')
  window.localStorage.removeItem('lastName')
  window.localStorage.removeItem('userPhone')
  window.localStorage.removeItem('userBirthDate')
  window.localStorage.removeItem('showDiary')
  if (vtexLogout && (process.env.ENV === 'staging' || process.env.ENV === 'production')) {
    await Axios.get('https://www.cobasi.com.br/api/vtexid/pub/logout?scope=www.cobasi.com.br', { withCredentials: true })
  }
  Sentry.configureScope(scope => scope.setUser(null))
}

export const validatePetanjoAuth = async (token) => {
  try {
    const { data } = await Axios({
      baseURL: config.user,
      url: '/integration/petanjo/auth/validate',
      method: 'post',
      withCredentials: true,
      headers: {
        'cache-control': 'no-cache',
        Authorization: `Bearer ${token}`
      }
    })

    if (!data.verified) {
      const { data: responseAccessKey } = await getAccessKey(data.email)
      const { authenticationToken } = responseAccessKey

      return {
        ...data,
        authenticationToken
      }
    }

    const ISPOSTLOGIN = false // flag para nao mandar um post em login
    const { user } = await authenticate({}, data, ISPOSTLOGIN)
    return { ...data, user }
  } catch (error) {
    return { unauthenticated: true }
  }
}
